import React from 'react'
import { inject, observer } from 'mobx-react'
import './index.scss'

//api
import { api } from '../../../../functions/api'

//material-ui
import TextField from '@material-ui/core/TextField'
import CircularProgress from '@material-ui/core/CircularProgress'
import Paper from '@material-ui/core/Paper'


//custom components
import CustomAvatar from '../../../../components/basic/customAvatar'
import CustomSnackbar from '../../../../components/global/snackbar'

//other libraries
import { toJS } from 'mobx'
import moment from 'moment'
import { debounce } from 'lodash/function'
import { Grid } from '@material-ui/core'

@inject('internal')
@inject('translate')
@observer
export default class ProductWarehouse extends React.Component {
  
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      message: null,
      openSnackbar: false,
    }
  }
  
  componentDidMount() {
  
  }
  
  loadBasicData = async () => {
    this.setState({ loading: true })
    let load_data = await api({
      method: 'get',
      url: 'products/' + this.props.routerData.match.params.idProduct,
      authorization: this.props.internal.user.access_token,
    })
    
    if (load_data.success && load_data.success === true) {
      this.props.internal.setDataForSimpeTable(load_data.data.data)
      
    }
    
    this.setState({ loading: false })
  }
  
  handleChangeWarehousePhoto = async (data) => {
    let idProduct = this.props.routerData.match.params.idProduct
    
    let upload_data = await api({
      method: 'post',
      url: 'products/' + idProduct + '/set-warehouse-photo',
      formData: true,
      formDataPut: true,
      authorization: this.props.internal.user.access_token,
      params: {
        warehouse_photo: data,
      },
    })
    
    
    if (upload_data.success && upload_data.success === true) {
      this.setState({ message: upload_data.data.message, openSnackbar: true })
      // this.props.internal.photoWasChanged(null)
      return Promise.resolve(false)
    }
  }
  
  handleChange = debounce(async (field, value) => {
    let idProduct = toJS(this.props.routerData.match.params.idProduct)
  
    let update_data = await api({
      method: 'patch',
      url: `products/${idProduct}/set-warehouse-location`,
      authorization: this.props.internal.user.access_token,
      params: {
        [field]: value
      }
    })
  
    if(update_data.success) {
      this.props.internal.setSnackbar(update_data.data.message, true)
    }
    else {
      this.props.internal.setSnackbar(update_data.data.message, true)
    }
  }, 500);
  
  render() {
    if (this.state.loading) {
      return <CircularProgress className={'circular-progress'}/>
    }
    
    let permissions = toJS(this.props.internal.user.data.permissions.products)
    
    return (
        <div className={'warehouse-container'}>
          <Paper className={'warehouse '} id="basicInfo">
            <CustomSnackbar message={this.state.message} open={this.state.openSnackbar}/>
            <div className={'product-image'}>
              <CustomAvatar
                src={this.props.internal.dataForSimpeTable.asset_warehouse_photo ? this.props.internal.dataForSimpeTable.asset_warehouse_photo : ''}
                actionUploadPhoto={this.handleChangeWarehousePhoto}
                disableEdit={! permissions.manage_warehouse}
              />
            </div>
            <div className={'warehouse-details'}>
              <Grid container spacing={16}>
                <Grid item xs={12} md={6}>
                  <TextField
                    disabled
                    label={this.props.translate.i18n.MODULES.PRODUCTS.CODE}
                    id="code"
                    defaultValue={this.props.internal.dataForSimpeTable.code}
                    className={'info-field'}
    
                    InputProps={{
                      disableUnderline: false,
                      disabled: true,
                      classes: {
                        underline: 'disabledUnderline',
                      },
                    }}
                  />
                  <TextField
                    label={this.props.translate.i18n.MODULES.PRODUCTS.WAREHOUSE_LOCATION}
                    id="name"
                    defaultValue={this.props.internal.dataForSimpeTable.warehouse_location}
                    className={'info-field'}
                    onChange={(event) => this.handleChange('warehouse_location', event.target.value)}
                    InputProps={{
                      disableUnderline: false,
                      disabled: !permissions.manage_warehouse,
                      classes: {
                        underline: !permissions.manage_warehouse ? 'disabledUnderline' : undefined,
                      },
                    }}
                  />
                  <TextField
                    disabled
                    label={this.props.translate.i18n.MODULES.PRODUCTS.WAREHOUSE_INFO}
                    id="code"
                    defaultValue={this.props.internal.dataForSimpeTable.warehouse_info}
                    className={'info-field'}
                    InputProps={{
                      disableUnderline: false,
                      disabled: true,
                      classes: {
                        underline: 'disabledUnderline',
                      },
                    }}
                  />
                  <TextField
                    disabled
                    label={this.props.translate.i18n.MODULES.PRODUCTS.WAREHOUSE_INFO_REAL}
                    id="code"
                    defaultValue={this.props.internal.dataForSimpeTable.warehouse_info_real}
                    className={'info-field'}
                    InputProps={{
                      disableUnderline: false,
                      disabled: true,
                      classes: {
                        underline: 'disabledUnderline',
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    disabled
                    label={this.props.translate.i18n.MODULES.PRODUCTS.NAME}
                    id="code"
                    defaultValue={this.props.internal.dataForSimpeTable.name}
                    className={'info-field'}
    
                    InputProps={{
                      disableUnderline: false,
                      disabled: true,
                      classes: {
                        underline: 'disabledUnderline',
                      },
                    }}
                  />
                  <TextField
                    disabled
                    label={this.props.translate.i18n.MODULES.PRODUCTS.CATEGORY}
                    id="code"
                    defaultValue={this.props.internal.dataForSimpeTable.category.name}
                    className={'info-field'}
    
                    InputProps={{
                      disableUnderline: false,
                      disabled: true,
                      classes: {
                        underline: 'disabledUnderline',
                      },
                    }}
                  />
                </Grid>
              </Grid>
              
            </div>
          </Paper>
        </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/screens/products/edit/warehouse/index.js